import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const systemLocale = "en-us"; //|| navigator.language;

const file_path = `/translations/${systemLocale}.json`;

fetch(file_path)
  .then((response) => response.json())
  .then((translation) => {
    i18n.use(initReactI18next).init({
      resources: {
        en: {
          translation,
        },
      },
      lng: "en", // default language
      fallbackLng: "en",
      interpolation: {
        escapeValue: false, // not needed for React
      },
    });
  });

export default i18n;
